let config = {}

config.serverAdress = "https://remotele-api.herokuapp.com" // production
//config.serverAdress = "http://192.168.1.13:3000" // test

module.exports = config